import { formatNumber, SupportedLocale } from 'core/utils/numberFormat';

const LETTER_GRADE_PATTERN = /^[A-Fa-f]$/;

/**
 * Formats a display score value using locale-aware number formatting.
 * Returns dashes, letter grades, and empty strings unchanged.
 * Preserves the decimal count from string inputs (e.g., "75.50" keeps 2 decimals).
 *
 * @param value - The score value to format
 * @param locale - The user's locale code (e.g., 'es', 'en', 'pt')
 * @returns The formatted score string
 */
export function formatDisplayScore(value: string | number | null | undefined, locale: SupportedLocale): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const stringValue = String(value);

  if (stringValue === '-') {
    return '-';
  }

  if (LETTER_GRADE_PATTERN.test(stringValue.trim())) {
    return stringValue;
  }

  const numericValue = Number(stringValue);

  if (isNaN(numericValue)) {
    return stringValue;
  }

  const options: Intl.NumberFormatOptions = {};
  const dotIndex = stringValue.indexOf('.');

  if (dotIndex !== -1) {
    const decimalCount = stringValue.length - dotIndex - 1;
    options.minimumFractionDigits = decimalCount;
    options.maximumFractionDigits = decimalCount;
  }

  return formatNumber(numericValue, locale, options);
}
